import React from 'react';
import {connect} from 'react-redux';

class NotFound extends React.Component {
  constructor(props){
    super(props);
    this.state = {

    }
  }

  componentWillMount(){
  }

  componentDidMount(){
  }



  render(){
    return(
      <div>
        <h1>Pagina não encontrada :(</h1>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {

  }
}

export default connect(mapStateToProps, {})(NotFound);



// WEBPACK FOOTER //
// ./src/views/NotFound.js